import {Component, OnInit} from '@angular/core';
import {UploadComponent} from "../../upload/upload.component";
import {User} from "../../../services/user/user";
import {UserService} from "../../../services/user/user.service";
import AppConstants from "../../../shared/common-components/AppConstants";

@Component({
    selector: 'app-tsp-xtos-batch-shipment-report',
    imports: [
        UploadComponent
    ],
    templateUrl: './tsp-xtos-batch-shipment-report.component.html',
    styleUrl: './tsp-xtos-batch-shipment-report.component.css'
})
export class TspXtosBatchShipmentReportComponent implements OnInit{
  currentUrl: any;
  currentUser: User;
  userRole: any = null;
  businessType: any = null;

  constructor(private userService: UserService) {}

  ngOnInit() {
    this.currentUrl = location.pathname;
    // this method is used to get the user details, instead of calling to server every time, by using behavioural subject
    this.userService.getUserDetails().subscribe(currentUser => {
      if (AppConstants.isNotNullCondition(currentUser)) {
        this.currentUser = currentUser;
        this.userRole = currentUser.roles[0].id;
        this.businessType = 'xtos'+currentUser.permissions;
      }
    }, (error) => {
      // this.alertService.info('unable to get current user details');
    });
  }

}
